import React, { Component } from 'react'
import { EditUnit } from './Unit'
import classnames from 'classnames'
import {
  getAddCohortByCalendarType,
  getDropCohortByCalendarType,
  getSemester1BlockModelCalendarTypes,
  getSemester2BlockModelCalendarTypes,
  getStudyPeriodCalendarTypes,
  getSummerBlockModelCalendarTypes,
  getSummerBlockModelOpeningCalendarTypes,
  getSummerBlockModelClosingCalendarTypes,
  getSemester1DualInstanceBlockModelCalendarTypes,
  getSemester2DualInstanceBlockModelCalendarTypes,
  getDualInstanceBlockWeek5CalendarTypes,
  getSupportedCalendarTypes,
  getUnitsByCalendarTypes,
  getWinterBlockModelCalendarTypes,
  getYearsEnrolled,
  isPlanUnit,
  getActiveEnrolledSingleInstanceCalendarTypeUnits,
  getActiveEnrolledDualInstanceCalendarTypeUnits,
  HIGHER_EDUCATION_SEMESTER_1,
  HIGHER_EDUCATION_SEMESTER_2,
  HIGHER_EDUCATION_SEMESTER_3,
  HIGHER_EDUCATION_SEMESTER_4,
  HIGHER_EDUCATION_MELBOURNE_TRIMESTER_1,
  HIGHER_EDUCATION_MELBOURNE_TRIMESTER_2,
  HIGHER_EDUCATION_MELBOURNE_TRIMESTER_3,
  HIGHER_EDUCATION_TRIMESTER_1,
  HIGHER_EDUCATION_TRIMESTER_2,
  HIGHER_EDUCATION_TRIMESTER_3,
  HIGHER_EDUCATION_OFFSHORE_1,
  HIGHER_EDUCATION_OFFSHORE_2,
  HIGHER_EDUCATION_OFFSHORE_3,
  HIGHER_EDUCATION_OFFSHORE_4,
  getAttributeCourseStaticInfo,
  getFlattenedUnitsWithMultipleAttendanceModes,
  getUnitsWithMultipleAttendanceModes,
  isChooseDeliveryToBeEnabled
} from '../../helpers/enrolment'
import { canRemoveUnitWithDropDate, getDropDateUnitText, unitDropDatePassed } from '../../helpers/unitDropDateHelper'
import AddUnitHolder from './AddUnitHolder'
import UndoUnitHolder from './UndoUnitHolder'
import { sortBy, uniq, uniqBy } from 'lodash'
import Skeleton from './Skeleton'
import { getReferences, getStudyPeriodToSemesterName, getStudyPeriodWeightings, getAttendanceModeCodesDetails, getAttendanceModeDescription } from '../../services/vu'
import Loading from './Loading'
import { Tooltip } from '@mui/material'
import BlockType from '../../enums/BlockType'
import NonBlockType from '../../enums/NonBlockType'
import UnitStatus from '../../enums/UnitStatus'
import UnitStage from '../../enums/UnitStage'
import AddUnitCallout from './AddUnitCallout'

class UnitTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      locations: [],
      studyPeriodWeightings: [],
      attendanceModeList: []
    }
  }

  componentDidMount() {
    Promise.all([getStudyPeriodWeightings(), getAttendanceModeCodesDetails()]).then(([studyPeriodWeightings, attendanceModeList]) => {
      this.setState({
        loading: false,
        studyPeriodWeightings: studyPeriodWeightings,
        attendanceModeList : attendanceModeList.referenceCodes
      })
    })

    getReferences().then(({ locationList = [] }) => {
      this.setState({
        locations: locationList
      })
    })
  }

  checkArrayContainsDuplicateUnits = units => {
    return units.filter(unit => unit.virtual !== true).length > 1
  }

  getBlockContainer = (children, calendarType, year, isBlockMode) => (
    <div className="col-xs-6 col-md-3" key={year + calendarType}>
      <div className="block-container">
        {isBlockMode && <div className="block">{calendarType}</div>}
        {React.Children.map(children, (child, index) => 
          React.cloneElement(child, { key: `${year + calendarType}-${index}` })
        )}
      </div>
    </div>
  )

  getBlockUnits = (calendarType, year, numberOfInstances, isAdmissionBlock, childrenArray = []) => {
    const allCalanderUnits = getUnitsByCalendarTypes(this.getEnrolledUnits(), [calendarType], year)

    let isInvalid = false;

    if (allCalanderUnits.length === 0 && isAdmissionBlock) {
      let noUnitCounter = 0 ;
      for (noUnitCounter = 0; noUnitCounter < numberOfInstances; noUnitCounter++) {
        let childern = this.getNoUnitHolder(isAdmissionBlock, calendarType, year)
        childrenArray.push(this.getBlockContainer(childern, calendarType, year, true))
      }
    } else if (allCalanderUnits.length > 0) {
      let splitUnitsBasedOnNumberOfInstances =[];

      if (numberOfInstances === 1) {
        splitUnitsBasedOnNumberOfInstances.push(allCalanderUnits)
        //isInvalid = allCalanderUnits.length > 1;
      } else {
        let odd = []
        let even = []
        let indexCounter = 0
        for (indexCounter = 0; indexCounter < allCalanderUnits.length; indexCounter++) {
          if (indexCounter % 2) {
            odd.push(allCalanderUnits[indexCounter])
          } else {
            even.push(allCalanderUnits[indexCounter])
          }
        }

        if (even.length > 0) {
          splitUnitsBasedOnNumberOfInstances.push(even)
        }
        if (odd.length > 0) {
          splitUnitsBasedOnNumberOfInstances.push(odd)
        }

        //isInvalid = even.length > 1 || odd.length > 1;
      }

      let unitsCounter = 0;
      for (unitsCounter = 0; unitsCounter < splitUnitsBasedOnNumberOfInstances.length;  unitsCounter++) {
        let childern = []
        let units = splitUnitsBasedOnNumberOfInstances[unitsCounter]
  
        let unitCounter = 0

        for (unitCounter = 0; unitCounter < units.length; unitCounter++) {
          let unit = units[unitCounter]
    
          if (!(unit.removed == true && unit.virtual == true)) {
            childern.push(this.getUnitHolder(unit, units.length > 1, isInvalid, calendarType, year))
          }
        }

        if (childern.length > 0) {
          childrenArray.push(this.getBlockContainer(childern, calendarType, year, true))
        }
      }

      if (numberOfInstances > 1 && splitUnitsBasedOnNumberOfInstances.length - numberOfInstances !== 0) {
        let loopCounter = 0;
        let requireCount = numberOfInstances - splitUnitsBasedOnNumberOfInstances.length

        for (loopCounter = 0; loopCounter < requireCount; loopCounter++) {
          let childern = this.getNoUnitHolder(isAdmissionBlock, calendarType, year)
          childrenArray.push(this.getBlockContainer(childern, calendarType, year, true))
        }
      }
    }

    return childrenArray
  }

  getUnitHolder = (unit, hasMultiple, isInvalid, calendarType, year) => {
    if (unit.removed) {
      if (this.props.firstPass) {
        return <UndoUnitHolder calendarType={calendarType} onClick={() => this.props.changeUnitUndoState(unit, false)} />
      } else if (!hasMultiple) {
        return <AddUnitHolder calendarType={calendarType} onClick={() => this.props.onAdd(calendarType, year)} />
      }
    } else if (isInvalid) {
      return this.getUnitBlockByValidity(unit, true)
    } else {
      return this.getUnitBlock(unit);
    }
  }

  getNoUnitHolder = (isAdmissionBlock, calendarType, year, isBlockMode) => {
    let childerns = []

    if (isAdmissionBlock && !(isBlockMode && this.props.firstPass && this.props.blockModelStudentPatternApplied)) {
      childerns.push(<div>
        <AddUnitHolder calendarType={calendarType} onClick={() => this.props.onAdd(calendarType, year)} />
      </div>)
    } else {
      childerns.push(
        <div className="unit-holder unit-holder--unavailable">
          <div className="unit-container">
            <div className="unit unit--unavailable">
              <h3>Unavailable</h3>
            </div>
          </div>
        </div>
      )
    }

    return childerns
  }


  isChooseDeliveryToBeEnabled = (unit, enrolledUnits) => {
    const unitInstances = enrolledUnits.filter(enrolledUnit => {
      return (
        enrolledUnit.virtual !== true &&
        enrolledUnit.unitAvailabilityStudyPeriodCode === unit.unitAvailabilityStudyPeriodCode &&
        enrolledUnit.unitAvailabilityYear === unit.unitAvailabilityYear &&
        enrolledUnit.unitCode === unit.unitCode &&
        enrolledUnit.unitAvailabilityLocationCode === unit.unitAvailabilityLocationCode
      )
    }).length

    return unitInstances > 1
  }

  getUnitBlockByValidity = (unit, invalid = false) => {
    //TODO withdrawable date logic for withdrawable
    const removeable = isPlanUnit(unit)
    const withdrawable = this.isWithdrawToBeEnabled(unit)
    //TODO editable if multiple attendance modes only
    const chooseDelivery = isChooseDeliveryToBeEnabled(unit, this.getActualEnrolments())

    const attendanceMode = isChooseDeliveryToBeEnabled(unit, this.getEnrolledUnits()) ? 'Multiple Delivery Modes' : getAttendanceModeDescription(this.state.attendanceModeList,unit.unitAvailabilityAttendanceModeCode)

    return (
      <Tooltip 
        disableInteractive={unit.virtual !== true} 
        disableHoverListener={unit.virtual !== true}
        disableFocusListener={unit.virtual !== true}
        className="tooltip" 
        placement="right" 
        followCursor={true} 
        title={this.getUnitTitle(unit)}
      >
        <>
          <div
            className={classnames(
              'unit-holder',
              { 'unit-holder--invalid': invalid },
              { 'unit-container--virtual': unit.virtual == true },
              {
                'unit-container--disabled':
                  unit.unitStatus === UnitStatus.PLANNED && (unit.unitAvailabilityMaxQuota > 0 && unit.unitAvailabilityQuotaRemaining !== null && unit.unitAvailabilityQuotaRemaining <= 0)
              },
              {
                'unit-holder--complete': unit.unitStatus === UnitStatus.PASS || unit.unitStatus === UnitStatus.FAIL
              }
            )}
          >
            <EditUnit
              code={unit.unitCode}
              name={unit.unitShortTitle}
              creditPoints={`${unit.unitCreditPoints || 0} points`}
              campus={unit.unitAvailabilityLocationDescription}
              core={false}
              editable={chooseDelivery}
              withdrawable={withdrawable}
              removeable={removeable}
              onEdit={() => this.props.onEdit(unit.unitCode, unit.unitAvailabilityStudyPeriodCode, unit.unitAvailabilityYear)}
              //onRemove={() => this.props.onRemove(unit)}
              onRemove={() => this.props.changeUnitUndoState(unit, true)}
              onWithdraw={() => this.props.onWithdraw(unit)}
              attendanceMode={attendanceMode}
            />
          </div>
          {withdrawable && getDropDateUnitText(unit)}
        </>
      </Tooltip>
    )
  }

  getWithdrawalDate = unit => {
    let unitWithdrawalDate = unit.lastEstudentWdDate !== null ? unit.lastEstudentWdDate : unit.lastWdDate !== null ? unit.lastWdDate : unit.availabilityEndDate
    return unitWithdrawalDate
  }

  isWithdrawToBeEnabled = unit => {
    let unitWithdrawalDate = new Date(this.getWithdrawalDate(unit))
    let today = new Date()
    today = new Date(today.toDateString())

    return (
      unit.unitStatus === UnitStatus.ENROLLED &&
      unit.unitStage === UnitStage.ENROLLED &&
      unit.selfWithdrawalFlag === true &&
      getAttributeCourseStaticInfo('courseSelfManageWithdrawalFlag') === 'Y' &&
      unitWithdrawalDate >= today
    )
  }

  getUnitBlock = unit => {
    // Flag enrolled units which share a unit code with another enrolled unit
    // as invalid
    const unitCode = unit.unitCode
    const unitAvailabilityStudyPeriodCode = unit.unitAvailabilityStudyPeriodCode
    const unitAvailabilityYear = unit.unitAvailabilityYear
    const unitsWithSameCode = this.getEnrolledUnits()
      .filter(unit => unit.unitStatus !== UnitStatus.FAIL) //Adding this filter to ignore completed units for Duplicate units calculation.
      .filter(unit => unit.unitCode === unitCode && unit.unitAvailabilityStudyPeriodCode !== unitAvailabilityStudyPeriodCode && unit.unitAvailabilityYear !== unitAvailabilityYear)

    //TODO what to do here for repeatable units
    // VUS-65: Enable repeating research units
    const nonRepeatableUnits = unitsWithSameCode
      //          .filter(({ repeatableInd }) => repeatableInd !== 'Y')
      .filter(({ virtual }) => virtual !== true)

    if (nonRepeatableUnits.length > 1) {
      return this.getUnitBlockByValidity(unit, true)
    }

    return this.getUnitBlockByValidity(unit, false)
  }

  getCampusByUnitLocationCd = unitLocationCd => {
    const location = this.state.locations.find(location => location.locationCd === unitLocationCd)
    if (location) {
      return location.description
    }
    return unitLocationCd
  }

  blockCalendarMandatory = (singleInstanceCalendarTypes, dualInstanceCalendarTypes) => {
    return (
      ((this.props.blockMode === BlockType.FourWeekBlock && singleInstanceCalendarTypes.length > 0) ||
        (this.props.blockMode === BlockType.EightWeekBlock && dualInstanceCalendarTypes.length > 0)) &&
      !this.props.firstPass
    )
  }

  getTeachingPeriodSortWeights = studyPeriodCode => {
    let studyPeriodWeighting = this.state.studyPeriodWeightings.filter(studyPeriodWeighting => studyPeriodWeighting.studyPeriodCode === studyPeriodCode)

    return studyPeriodWeighting.length > 0 ? studyPeriodWeighting[0].sortOrder : 1000
  }

  blockModelSemester = (title, year, semesterCalendarType, blockCalendarTypes = [], dualInstanceCalendarTypes = [], mandatory = false, displaySCT = false) => {
    const allCalendarTypes = blockCalendarTypes
      .concat(dualInstanceCalendarTypes)
      .concat(semesterCalendarType)
      .filter(calendarType => calendarType !== '')

    // If the student has not enrolled into this teaching period and it is not
    // mandatory to render the table then don't render the table.
    const hasNotEnrolledIntoTeachingPeriod = getUnitsByCalendarTypes(this.getEnrolledUnits(), allCalendarTypes, year).length === 0

    // If the student is fyc block model student and can add units
    // show the winter and summer semester
    this.blockCalendarMandatory(blockCalendarTypes, dualInstanceCalendarTypes) ? (mandatory = true) : mandatory

    if (hasNotEnrolledIntoTeachingPeriod && !(mandatory && (this.props.blockMode === BlockType.FourWeekBlock || this.props.blockMode === BlockType.EightWeekBlock))) {
      return null
    }
    const enrolledUnits = getUnitsByCalendarTypes(this.getEnrolledUnits(), this.props.blockStatus ? [semesterCalendarType] : allCalendarTypes, year).sort((a, b) => {
      if (this.getTeachingPeriodSortWeights(a.unitAvailabilityStudyPeriodCode) < this.getTeachingPeriodSortWeights(b.unitAvailabilityStudyPeriodCode)) {
        return -1
      }

      if (this.getTeachingPeriodSortWeights(a.unitAvailabilityStudyPeriodCode) > this.getTeachingPeriodSortWeights(b.unitAvailabilityStudyPeriodCode)) {
        return 1
      }

      return 0
    })

    let templatedCalendarTypes = []
    let nonTemplatedCalendarTypes = []

    if (this.props.blockStatus) {
      //dual instance or single instance template first
      if (this.props.blockMode === BlockType.EightWeekBlock) {
        templatedCalendarTypes = dualInstanceCalendarTypes
        nonTemplatedCalendarTypes = blockCalendarTypes
      } else {
        templatedCalendarTypes = blockCalendarTypes
        nonTemplatedCalendarTypes = dualInstanceCalendarTypes
      }
    }

    return (
      <Skeleton title={title}>
        {this.props.blockStatus && (
          <div className="row">
            {templatedCalendarTypes.length > 0 &&
              templatedCalendarTypes.map(calendarType =>
                this.getBlockUnits(
                  calendarType,
                  year,
                  this.isEightWeekBlockCalendar(calendarType) ? 2 : 1,
                  this.isEightWeekBlockCalendar(calendarType) ? this.props.blockMode === BlockType.EightWeekBlock : this.props.blockMode === BlockType.FourWeekBlock
                )
              )}
            {nonTemplatedCalendarTypes.length > 0 &&
              nonTemplatedCalendarTypes.map(calendarType =>
                this.getBlockUnits(
                  calendarType,
                  year,
                  this.isEightWeekBlockCalendar(calendarType) ? 2 : 1,
                  this.isEightWeekBlockCalendar(calendarType) ? this.props.blockMode === BlockType.EightWeekBlock : this.props.blockMode === BlockType.FourWeekBlock
                )
              )}
          </div>
        )}
        {(enrolledUnits.length > 0 || !this.props.firstPass) && (
          <div className="row">
            {sortBy(enrolledUnits, function(unit) {
              return new Date(unit.unitStartDate)
            }).map(unit => {
              return (
                <div className="col-xs-6 col-md-3" key={unit.unitCd}>
                  <div className="block-container">
                    <div className="block">{unit.unitAvailabilityStudyPeriodCode}</div>
                    {this.getUnitBlock(unit)}
                  </div>
                </div>
              )
            })}

            {semesterCalendarType !== '' && displaySCT && (
              <div className="col-xs-6 col-md-3">
                <div className="block-container">
                  <div className="block">{semesterCalendarType}</div>
                  <AddUnitHolder calendarType={semesterCalendarType} onClick={() => this.props.onAdd(semesterCalendarType, year)} />
                </div>
              </div>
            )}
          </div>
        )}
      </Skeleton>
    )
  }

  isEightWeekBlockCalendar = calendarType => {
    return calendarType.indexOf('H8W') > -1
  }

  studyPeriodSemester = year => {
    const studyPeriodCalendarTypes = getStudyPeriodCalendarTypes()

    if (getUnitsByCalendarTypes(this.getEnrolledUnits(), studyPeriodCalendarTypes, year).length === 0) {
      return null
    }

    return (
      <Skeleton title={`${year} - Study periods`}>
        <div className="row">
          {studyPeriodCalendarTypes.map(calendarType => {
            return this.getBlockUnits(calendarType, year, 1, true)
          })}
        </div>
      </Skeleton>
    )
  }

  calendarSemesterGridOnlyIfEnrolled = (title, year, semesterCalendarType) => {
    if (getUnitsByCalendarTypes(this.getEnrolledUnits(), [semesterCalendarType], year).length === 0) {
      return null
    }

    const enrolledUnits = getUnitsByCalendarTypes(this.getEnrolledUnits(), [semesterCalendarType], year)
    if (enrolledUnits.length === 0) {
      return null
    }

    return (
      <Skeleton title={title}>
        <div className="row">
          {sortBy(enrolledUnits, function(unit) {
            return new Date(unit.unitStartDate)
          }).map(unit => {
            return (
              <div className="col-xs-6 col-md-3" key={unit.unitCd}>
                <div className="block-container">
                  <div className="block">{unit.unitAvailabilityStudyPeriodCode}</div>
                  {this.getUnitBlock(unit)}
                </div>
              </div>
            )
          })}

          <div className="col-xs-6 col-md-3">
            <div className="block-container">
              <div className="block" />
              <AddUnitHolder calendarType={semesterCalendarType} onClick={() => this.props.onAdd(semesterCalendarType, year)} />
            </div>
          </div>
        </div>
      </Skeleton>
    )
  }

  getEnrolledUnits = () => this.props.units.filter(({ unitAvailabilityYear }) => unitAvailabilityYear === this.props.enrolYear)

  getActualEnrolments = () => this.props.currentEnrolment.filter(({ unitAvailabilityYear }) => unitAvailabilityYear === this.props.enrolYear)

  getSuggestedUnits = () => {
    return this.props.suggestedUnits
  }

  getUnitTitle = unit => {
    if (unit.virtual) {
      return `${unit.unitCode} runs across ${unit.unitCreditPoints / 12} blocks. Further enrolment in this block is unavailable.`
    } else if (isPlanUnit(unit)) {
      if (unit.unitAvailabilityQuotaRemaining === 0) {
        return 'This unit from your pattern of study is currently full. For assistance please contact VUHQ.'
      }
      // else if (unit.patternstatus === 'ERROR') {
      //   return `A unit has not been populated here due to one of the following reasons. You may have Advance Standing or a unit may not be offered in this block. For assistance, please contact VUHQ`
      // }
    }
    return ''
  }

  getUnsupportedUnitSections = year => {
    if (this.getEnrolledUnits().length > 0) {
      return this.getUnsupportedCalendarTypes().map(calendarType => {
        return this.calendarSemesterGrid(`${year} - ${calendarType}`, year, calendarType)
      })
    }

    return null
  }

  getUnsupportedCalendarTypes = () => {
    return uniq(
      this.getEnrolledUnits()
        .filter(unit => !getSupportedCalendarTypes().some(calendarType => calendarType === unit.unitAvailabilityStudyPeriodCode))
        .map(unit => unit.unitAvailabilityStudyPeriodCode)
    )
  }

  hasDuplicates = (array, maxInstances = 1) => {
    let countedInstances = {}
    let i = 0
    for (i = 0; i < array.length; i++) {
      const value = array[i]
      countedInstances[value] = countedInstances[value] ? countedInstances[value] + 1 : 1

      if (countedInstances[value] > maxInstances) {
        return true
      }
    }
    return false
  }

  getValidationErrors = () => {
    return this.getHasDoubleUppedBlockUnits('FourWeek') || this.getHasDoubleUppedBlockUnits('EightWeek')
  }

  getMultipleAttendanceModeText = () => {
    const unitsWithMultipleAttendanceModes = getUnitsWithMultipleAttendanceModes(this.getEnrolledUnits())

    return (
      unitsWithMultipleAttendanceModes.length > 0 && (
        <div className="sidenote sidenote--info">
          <div className="sidenote__content">
            <p>You will need to select delivery for the following units before you can submit your enrolment: '{unitsWithMultipleAttendanceModes.join()}' .</p>
          </div>
        </div>
      )
    )
  }

  /**
   * Checks the student's enrolment to see if they have double-upped an
   * enrolment for a particular block model calendar type, e.g. SEM-1-B1.
   *
   * @return {boolean}
   */
  getHasDoubleUppedBlockUnits = (calendarType = 'FourWeek') => {
    // Creates a array of strings from the actively enrolled block model units
    // into the following pattern:
    //
    // 2018-SEM-1-B1
    // 2018-SEM-1-B2
    //
    // If there is a duplicate string in the array for Four week or more than two for eight week blocks
    //  then we have more units enrolled than allowed into the respective block model period.
    const enrolledUnits =
      calendarType === 'FourWeek'
        ? getActiveEnrolledSingleInstanceCalendarTypeUnits(this.getEnrolledUnits().filter(unit => unit.unitAvailabilityYear === parseInt(this.props.enrolYear)))
        : getActiveEnrolledDualInstanceCalendarTypeUnits(this.getEnrolledUnits().filter(unit => unit.unitAvailabilityYear === parseInt(this.props.enrolYear)))
    const filteredSameBlockUnits = getFlattenedUnitsWithMultipleAttendanceModes(enrolledUnits.filter(unit => unit.virtual !== true))
    const unitCalendarArray = filteredSameBlockUnits.map(unit => `${unit.unitAvailabilityYear}-${unit.unitAvailabilityStudyPeriodCode}`)
    let maxInstances = calendarType === 'FourWeek' ? 1 : 2
    return this.hasDuplicates(unitCalendarArray, maxInstances)
  }

  calendarMandatory = (calendarTypes, blockCodeType) => {
    return this.props.blockMode === blockCodeType
    // return (this.props.blockMode === blockModeType && !this.props.firstPass)
  }

  getAddUnit = (semesterCalendarType, addUnitCount = 1, year) => {
    if (addUnitCount <= 0) {
      return null
    }
    return Array(addUnitCount)
      .fill(null)
      .map((x, i) => {
        return (
          <div key={i} className="col-xs-6 col-md-3">
            <div className="block-container">
              <div className="block" />
              <AddUnitHolder calendarType={semesterCalendarType} onClick={() => this.props.onAdd(semesterCalendarType, year)} />
            </div>
          </div>
        )
      })
  }

  calendarSemesterGrid = (title, year, semesterCalendarType, blockCodeType = '') => {
    let isOnStudyGuide = this.props.studyPackages.filter(studyPackage => studyPackage.unitAvailabilityStudyPeriodCode === semesterCalendarType).length > 0
    const hasNotEnrolledIntoTeachingPeriod = getUnitsByCalendarTypes(this.getEnrolledUnits(), [semesterCalendarType], year).length === 0
    let addUnitCount = 4

    let mandatory = this.calendarMandatory(semesterCalendarType, blockCodeType) && isOnStudyGuide ? true : false

    if (hasNotEnrolledIntoTeachingPeriod && !(mandatory && this.props.blockMode === blockCodeType)) {
      return null
    }

    const enrolledUnits = getUnitsByCalendarTypes(this.getEnrolledUnits(), [semesterCalendarType], year)

    addUnitCount -= enrolledUnits.length

    let counter = 0

    return (
      <Skeleton key={title + year} title={title}>
        <div className="row">
          {enrolledUnits.length > 0 &&
            sortBy(enrolledUnits, function(unit) {
              return new Date(unit.unitStartDate)
            }).map(unit => {
              return (
                <div className="col-xs-6 col-md-3" key={unit.unitCd}>
                  <div className="block-container">
                    <div className="block">{unit.unitAvailabilityStudyPeriodCode}</div>
                    {this.getUnitBlock(unit)}
                  </div>
                </div>
              )
            })}

          {this.getAddUnit(semesterCalendarType, addUnitCount, year)}
        </div>
      </Skeleton>
    )
  }

  render() {
    if (this.props.loading) {
      return <Loading message="Loading your units..." />
    }

    const year = parseInt(this.props.enrolYear)

    if (this.props.studyPackages.length === 0 && this.getEnrolledUnits().length === 0) {
      return (
        <div className="sidenote">
          <div className="sidenote__content">
            There are no units available in your study plan. Please contact{' '}
            <a href="https://www.vu.edu.au/contact-us" target="_blank">
              VUHQ
            </a>{' '}
            to discuss your enrolment.
          </div>
        </div>
      )
    }

    return (
      <div>
        {this.getValidationErrors() && (
          <div className="question-group">
            <div className="sidenote sidenote--error">
              <div className="sidenote__content">
                {(this.getHasDoubleUppedBlockUnits('FourWeek') || this.getHasDoubleUppedBlockUnits('EightWeek')) && (
                  <p>
                    Your enrolment has more than one unit in one 4 Week Teaching Block and/or more than two units in one 8 Week Teaching Block. Please review your enrolment. For any
                    assistance contact{' '}
                    <a href="https://www.vu.edu.au/contact-us" target="_blank">
                      VUHQ
                    </a>
                    .
                  </p>
                )}
              </div>
            </div>
          </div>
        )}

        {this.getMultipleAttendanceModeText()}

        <div key={year}>
          {this.studyPeriodSemester(year)}
          {this.blockModelSemester(`${year} - Summer Block (January)`, year, '', getSummerBlockModelOpeningCalendarTypes())}
          {this.blockModelSemester(
            `${year} - Semester 1`,
            year,
            HIGHER_EDUCATION_SEMESTER_1,
            getSemester1BlockModelCalendarTypes(),
            getSemester1DualInstanceBlockModelCalendarTypes(),
            true,
            false
          )}
          {this.blockModelSemester(`${year} - Winter Block`, year, HIGHER_EDUCATION_SEMESTER_4, getWinterBlockModelCalendarTypes())}
          {this.blockModelSemester(
            `${year} - Semester 2`,
            year,
            HIGHER_EDUCATION_SEMESTER_2,
            getSemester2BlockModelCalendarTypes(),
            getSemester2DualInstanceBlockModelCalendarTypes(),
            true,
            false
          )}
          {this.blockModelSemester(`${year} - 8 Week - Block 5`, year, '', [], getDualInstanceBlockWeek5CalendarTypes())}
          {this.calendarSemesterGridOnlyIfEnrolled(`${year} - Trimester 1`, year, HIGHER_EDUCATION_MELBOURNE_TRIMESTER_1)}
          {this.calendarSemesterGridOnlyIfEnrolled(`${year} - Trimester 2`, year, HIGHER_EDUCATION_MELBOURNE_TRIMESTER_2)}
          {this.calendarSemesterGridOnlyIfEnrolled(`${year} - Trimester 3`, year, HIGHER_EDUCATION_MELBOURNE_TRIMESTER_3)}
          {this.calendarSemesterGridOnlyIfEnrolled(`${year} - Trimester 1`, year, HIGHER_EDUCATION_TRIMESTER_1)}
          {this.calendarSemesterGridOnlyIfEnrolled(`${year} - Trimester 2`, year, HIGHER_EDUCATION_TRIMESTER_2)}
          {this.calendarSemesterGridOnlyIfEnrolled(`${year} - Trimester 3`, year, HIGHER_EDUCATION_TRIMESTER_3)}
          {this.calendarSemesterGridOnlyIfEnrolled(`${year} - Summer Semester`, year, HIGHER_EDUCATION_SEMESTER_3)}

          {this.calendarSemesterGrid(`${year} - Offshore 1`, year, HIGHER_EDUCATION_OFFSHORE_1, NonBlockType.OFFSHORE)}
          {this.calendarSemesterGrid(`${year} - Offshore 2`, year, HIGHER_EDUCATION_OFFSHORE_2, NonBlockType.OFFSHORE)}
          {this.calendarSemesterGrid(`${year} - Offshore 3`, year, HIGHER_EDUCATION_OFFSHORE_3, NonBlockType.OFFSHORE)}
          {this.calendarSemesterGrid(`${year} - Offshore 4`, year, HIGHER_EDUCATION_OFFSHORE_4, NonBlockType.OFFSHORE)}

          {this.getUnsupportedUnitSections(year)}

          {((!this.props.blockModelStudentPatternApplied && this.props.firstPass) || (!this.props.firstPass && !this.props.strictPattern)) && (
            <AddUnitCallout blockStatus={this.props.blockStatus} enrollingForFirstTime={this.props.enrollingForFirstTime} handleAddUnitCallout={this.props.handleAddUnitCallout} />
          )}
        </div>
      </div>
    )
  }
}

export default UnitTable
